// extracted by mini-css-extract-plugin
export var copyRight = "Footer-module--copyRight--2770d";
export var designedBy = "Footer-module--designedBy--fdd55";
export var footer = "Footer-module--footer--b93ce";